export const MULTISESSIONKEY = 'ERPMULTIMODULE'

export const setMultiModuleData = function (data) {
  if (data) {
    sessionStorage.setItem(MULTISESSIONKEY, JSON.stringify(data))
  }
}

export const getMultiModuleData = function () {
  const data = sessionStorage.getItem(MULTISESSIONKEY)
  if (data) {
    return JSON.parse(data)
  }
}



// WEBPACK FOOTER //
// ./src/layout/utils/index.js